(function($){

	$(".navbar-toggler").click(function(){
		$(".navbar__sticky").toggleClass("show");
	});

	// Scrolltop button
	/*
	$('#btn-up').click(function(e){
		e.preventDefault();
		$('body,html').animate({scrollTop:0}, 500);
	});
	$(window).scroll(function () {
		if ($(window).scrollTop() > 301) {
			$('#btn-up').removeClass('disabled');
		}
		if ($(window).scrollTop() < 300) {
			$('#btn-up').addClass('disabled');
		}
	});
	*/

	var swiper = new Swiper('.gallery', {
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: '.section--gallery .swiper-button-next',
			prevEl: '.section--gallery .swiper-button-prev',
		},
		breakpoints: {
			// when window width is >= 320px
			400: {
				slidesPerView: 2,
				spaceBetween: 15
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30
			},
			1640: {
				slidesPerView: 5,
				spaceBetween: 30
			}
		}
	});

	/* Swipebox */

	$('.swipebox').swipebox({
		hideBarsDelay : 5000, // delay before hiding bars on desktop
		loopAtEnd: true // true will return to the first image after the last image is reached
	});

/*
	//Autocomplete
	var searchInput = $('#search-input');
	searchInput.focus();

	var count = 0;
	var term = '';

	var autocomplete = searchInput.autocomplete({
		delay: 200,
		minLength: 1,
		source: function (request, response) {
			$.ajax({
				url: searchInput.data('source'),
				data: {q: request.term},
				success: function (payload) {
					if (payload.data.searchItems.length > 0) {

						count = payload.data.count;
						term = request.term;

						response($.map(payload.data.searchItems, function (item) {
							item.name = __highlight(item.name, request.term);
							return item;
						}), request.term);
					} else {
						response([
							{label: 'Nic nenalezeno.', name: 'empty'}
						]);
					}
				}
			});
		},
		messages: {
			noResults: '',
			results: function () {
			}
		},
		select: function (e, ui) {
			return false;
		},
		open: function (e, ui) {
			$(".ui-autocomplete:visible").addClass('header-autocomplete').css({
				top: "+=10",
				left: "-=123"
			});

			if (count > 10) {
				var content = $('<div>', {
					'id': 'ui-footer'
				}).html('Bylo nalezeno více výsledků, specifikujte blíže');
				content.appendTo($('.ui-autocomplete'));
			}
		},
		close: function (e, ui) {
			$(".ui-autocomplete").show();
		},
		create: function () {
			$(this).data('ui-autocomplete')._renderItem = function (ul, item) {

				if (item.name == 'empty') {

					var content = $('<li>', {
						class: 'empty'
					}).html(item.label);

					return content.appendTo(ul);

				} else {
					var content = $('<a>', {
						href: item.link,
						class: 'ui-item ' + item.type
					});

					var img = $('<img>', {
						src: item.image,
						class: 'left'
					});

					var div = $('<div>', {
						class: 'left'
					}).append($('<div>').html(item.name));

					if (item.type == "product") {
						content.append(img);
					}

					content.append(div);

					return content.appendTo(ul);
				}
			};

			// $(this).data("uiAutocomplete").menu.element.addClass("my_class");
		}
	});

	// highlight autocomplete match
	function __highlight(s, t) {
		var string = s;
		var tokens = t.split(/[ ]+/);

		for (var i = 0; i < tokens.length; i++) {
			string = string.replace(new RegExp("((?!<[^>]*)" + tokens[i] + "(?![^<]*>))", "gi"), "<strong>$1</strong>");
		}

		return string;
	}

	$(document).mouseup(function () {
		$(".ui-autocomplete").hide();
	});

	searchInput.on('input', function () {
		if ($(this).val().length === 0)
			$(".ui-autocomplete").hide();
	});
*/

	$('.addToCart').submit(function(e){
		e.preventDefault();

		$.nette.ajax({
			method: 'GET',
			url: $(this).prop('action'),
			data: $(this).serialize(),
			complete: function(){
				$('#cart-dropdown').addClass('open');
			}
		});
	});

})(jQuery);